/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbApprenantHistoryGridDto } from './FcbApprenantHistoryGridDto';
import {
    FcbApprenantHistoryGridDtoFromJSON,
    FcbApprenantHistoryGridDtoFromJSONTyped,
    FcbApprenantHistoryGridDtoToJSON,
} from './FcbApprenantHistoryGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbApprenantHistoryGridDtoPaginatedResults
 */
export interface FcbApprenantHistoryGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantHistoryGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbApprenantHistoryGridDto>}
     * @memberof FcbApprenantHistoryGridDtoPaginatedResults
     */
    results?: Array<FcbApprenantHistoryGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbApprenantHistoryGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbApprenantHistoryGridDtoPaginatedResults interface.
 */
export function instanceOfFcbApprenantHistoryGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbApprenantHistoryGridDtoPaginatedResultsFromJSON(json: any): FcbApprenantHistoryGridDtoPaginatedResults {
    return FcbApprenantHistoryGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbApprenantHistoryGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbApprenantHistoryGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbApprenantHistoryGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbApprenantHistoryGridDtoPaginatedResultsToJSON(value?: FcbApprenantHistoryGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbApprenantHistoryGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

